export default __webpack_public_path__ + "static/lt-804d1eeb47746b1b7ef7200c167be99f.svg";